import React, { useEffect, useState } from 'react';
import { SolarProvider, SolarUser } from '../../types/solar_user';
import { addSolarUser, getAllProviders } from '../../services/solarService';



const AddSolarUser: React.FC = () => {
  const [solarProviders, setSolarProvider] = useState<SolarProvider[]>([]);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);

  useEffect(() => {
    getAllProviders({}).then((data) => {
      setSolarProvider(prevProviders => [...prevProviders, data]);

    }).catch((error) => {
      console.error('Error fetching providers:', error);
    });
  }, []);
  const [user, setUser] = useState<SolarUser>({
    provider_id: '',
    user_id: 0,
    user_name: '',
    password: '',
    capacity: '',
    capacity_unit: '',
    consumer_name: '',
    consumer_type: '',
    discom_number: '',
    created_by: localStorage.getItem('user_id') ? parseInt(localStorage.getItem('user_id') || '1', 10) : 1,
    updated_by: localStorage.getItem('user_id') ? parseInt(localStorage.getItem('user_id') || '1', 10) : 1,
    provider_name: '',
    updated_at: '',
    address_line1: '',
    address_line2: '',
    village: '',
    taluka: '',
    district: '',
    zip_code: '',
    lat_long: '',
    country: '',
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // Call API to add user
    console.log(user);
    addSolarUser(user)
      .then((response) => {
        console.log('User added successfully:', response);
        // Scroll to top so the modal is visible immediately
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch { window.scrollTo(0, 0); }
        setShowSuccessModal(true);
      })
      .catch((error) => {
        console.error('Error adding user:', error);
      });
  };

  return (
    <div className="row">

      <div className="col-xl-12 col-lg-12 col-md-12">

        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body">
              {showSuccessModal && (
                <>
                  <div className="modal fade show d-block" role="dialog" aria-modal="true">
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">User Created</h5>
                          <button type="button" className="close" aria-label="Close" onClick={() => setShowSuccessModal(false)}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <p>User created successfully{user.user_name ? `: ${user.user_name}` : ''}.</p>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setShowSuccessModal(false);
                              try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch { window.scrollTo(0, 0); }
                              // Focus first field to quickly add another user
                              const first = document.querySelector('select[name="provider_id"]') as HTMLElement | null;
                              first?.focus();
                              // Reset form after closing success modal
                              setUser({
                                provider_id: '',
                                user_id: 0,
                                user_name: '',
                                password: '',
                                capacity: '',
                                capacity_unit: '',
                                consumer_name: '',
                                consumer_type: '',
                                discom_number: '',
                                created_by: localStorage.getItem('user_id') ? parseInt(localStorage.getItem('user_id') || '1', 10) : 1,
                                updated_by: localStorage.getItem('user_id') ? parseInt(localStorage.getItem('user_id') || '1', 10) : 1,
                                provider_name: '',
                                updated_at: '',
                                address_line1: '',
                                address_line2: '',
                                village: '',
                                taluka: '',
                                district: '',
                                zip_code: '',
                                lat_long: '',
                                country: '',
                              });
                            }}
                          >
                            Add New Solar User
                          </button>
                          <button type="button" className="btn btn-primary" onClick={() => { window.location.href = '/solar-users'; }}>
                            Go to Solar User List
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show"></div>
                </>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-xl-6 col-lg-6'>
                    <div className="form-group">
                      <label>
                        Provider Name:
                        <select
                          name="provider_id"
                          className="form-control form-control-user"
                          onChange={handleChange}
                          value={user.provider_id}>
                          <option key="-1" value="">Select Provider</option>
                          {solarProviders.map((provider) => (
                            provider.data.map(element => (
                              <option key={element.provider_id} value={element.provider_id}>
                                {element.provider_name}
                              </option>
                            ))
                          ))}
                        </select>
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Solar User Name:
                        <input
                          type="text"
                          name="user_name"
                          className="form-control form-control-user"
                          value={user.user_name}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Solar Consumer Name:
                        <input
                          type="text"
                          name="consumer_name"
                          className="form-control form-control-user"
                          value={user.consumer_name}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Solar Consumer Type:
                        <input
                          type="text"
                          name="consumer_type"
                          className="form-control form-control-user"
                          value={user.consumer_type}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Solar Consumer Discom Number:
                        <input
                          type="text"
                          name="discom_number"
                          className="form-control form-control-user"
                          value={user.discom_number}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Solar Password:
                        <input
                          type="password"
                          name="password"
                          className="form-control form-control-user"
                          value={user.password}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Capacity:
                        <input
                          type="text"
                          name="capacity"
                          className="form-control form-control-user"
                          value={user.capacity}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Capacity Unit:
                        <input
                          type="text"
                          name="capacity_unit"
                          className="form-control form-control-user"
                          value={user.capacity_unit}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                  </div>
                  <div className='col-xl-6 col-lg-6'>
                    <div className="form-group">
                      <label>
                        Address Line 1:
                        <input
                          type="text"
                          name="address_line1"
                          className="form-control form-control-user"
                          value={user.address_line1}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Address Line 2:
                        <input
                          type="text"
                          name="address_line2"
                          className="form-control form-control-user"
                          value={user.address_line2}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Village
                        <input
                          type="text"
                          name="village"
                          className="form-control form-control-user"
                          value={user.village}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Taluka
                        <input
                          type="text"
                          name="taluka"
                          className="form-control form-control-user"
                          value={user.taluka}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        District
                        <input
                          type="text"
                          name="district"
                          className="form-control form-control-user"
                          value={user.district}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Pin Code
                        <input
                          type="text"
                          name="zip_code"
                          className="form-control form-control-user"
                          value={user.zip_code}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Lat Long
                        <input
                          type="text"
                          name="lat_long"
                          className="form-control form-control-user"
                          value={user.lat_long}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="form-group">
                      <label>
                        Country
                        <input
                          type="text"
                          name="country"
                          className="form-control form-control-user"
                          value={user.country}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group modal-footer justify-content-end">
                  <button className="btn btn-primary" type="submit">Add User</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};

export default AddSolarUser;